import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faBookmark } from '@fortawesome/free-solid-svg-icons/faBookmark';
import { faBug } from '@fortawesome/free-solid-svg-icons/faBug';
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons/faCloudDownloadAlt';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons/faFileCsv';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faMoon } from '@fortawesome/free-solid-svg-icons/faMoon';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faChartBar } from '@fortawesome/free-solid-svg-icons/faChartBar';
import { faNewspaper } from '@fortawesome/free-solid-svg-icons/faNewspaper';
import { faBookOpen } from '@fortawesome/free-solid-svg-icons/faBookOpen';
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook';
import { faSun } from '@fortawesome/free-solid-svg-icons/faSun';
import { faTag } from '@fortawesome/free-solid-svg-icons/faTag';
import { faApple } from '@fortawesome/free-brands-svg-icons/faApple';
import { faAndroid } from '@fortawesome/free-brands-svg-icons/faAndroid';
import { faBookmark as regFaBookmark } from '@fortawesome/free-regular-svg-icons/faBookmark';
import { faCheckCircle as regFaCheckCircle } from '@fortawesome/free-regular-svg-icons/faCheckCircle';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faComments } from '@fortawesome/free-regular-svg-icons/faComments';
import { faFile } from '@fortawesome/free-regular-svg-icons/faFile';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons/faFileExcel';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons/faFilePdf';
import { faFilePowerpoint } from '@fortawesome/free-regular-svg-icons/faFilePowerpoint';
import { faFileWord } from '@fortawesome/free-regular-svg-icons/faFileWord';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons/faTrashAlt';
import { faQuestion } from '@fortawesome/free-solid-svg-icons/faQuestion';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons/faThumbsUp';
import { faThumbsUp as regFaThumbsUp} from '@fortawesome/free-regular-svg-icons/faThumbsUp';
import { faThumbsDown } from '@fortawesome/free-solid-svg-icons/faThumbsDown';
import { faThumbsDown as regFaThumbsDown } from '@fortawesome/free-regular-svg-icons/faThumbsDown';
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle';
import { faCircle as regFaCircle } from '@fortawesome/free-regular-svg-icons/faCircle';
import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import VueGtag from "vue-gtag";
import App from './App.vue';
import router from './router';
import store from './store';
import oidcClient from '@api/oidcClient';

// add the solid icons
library.add(faArrowUp, faBars, faBookmark, faBug, faCheckCircle, faCircle, faCog, faChevronDown, faChevronUp, faCloudDownloadAlt, faExclamationTriangle, faFileCsv, faExternalLinkAlt, faInfoCircle, faMoon, faSpinner, faLock, faUser, faChartBar, faNewspaper, faBookOpen, faBook, faSun, faTag, faThumbsDown, faThumbsUp, faQuestion);

// add the regular icons
library.add(regFaBookmark, regFaCheckCircle, faComments, faFile, faFileExcel, faFilePdf, faFilePowerpoint, faFileWord, regFaCircle, regFaThumbsDown, regFaThumbsUp, faTrashAlt);

// add the brand icons
library.add(faApple, faAndroid);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueScrollTo);

store.dispatch('content/loadAndGetEnvironment').then((environment) => {
  Vue.use(VueGtag, {
    config: {
      id: environment.VUE_APP_GOOGLE_ANALYTICS_ID
    },
    bootstrap: false
  }, router);

  // now that we got the environment, init the OIDC client
  oidcClient.init(environment);

  Vue.config.productionTip = false;

  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
});